var hidden, visibilityChange;

declare var document: any;

if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
} else if (typeof document.mozHidden !== 'undefined') {
    hidden = 'mozHidden';
    visibilityChange = 'mozvisibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
}

var _isHidden = false;
var initialized = false;
var _glob;

function handleVisibilityChange() {
    _isHidden = document[hidden];

    _glob.AppActions.pageVisibilityChange(!_isHidden);
}

export function init(glob) {
    if (typeof document.addEventListener === 'undefined' || typeof document[hidden] === 'undefined' || initialized) {
        return;
    }

    _isHidden = document[hidden];
    _glob = glob;

    document.addEventListener(visibilityChange, handleVisibilityChange, false);

    initialized = true;
}

export function destroy() {
    if (initialized) {
        document.removeEventListener(visibilityChange, handleVisibilityChange);
    }
}

export function isVisible() {
    return !_isHidden;
}

export function isHidden() {
    return _isHidden;
}
